import { JobsContainer, SearchContainer } from "../../components";

function AllJobs() {
  return (
    <>
      <SearchContainer />
      <JobsContainer />
    </>
  );
}

export default AllJobs;
